/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "@/src/components/Container/Container";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import LpTenancyLawAdvocardMeta from "./LpTenancyLawAdvocardMeta";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "@/src/services/landingPageService";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import TenancyLawCheckin from "@/src/components/Checkin/TenancyLawCheckin/TenancyLawCheckin";
import HowItWorksSectionTenancyLaw from "@/src/components/Sections/TenancyLaw/HowItWorksSection/HowItWorksSectioTenancyLaw";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const LpTenancyLawAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      <LpTenancyLawAdvocardMeta />
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Fragen oder Probleme im Bereich Mietrecht?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <TenancyLawCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
      <HowItWorksSectionTenancyLaw />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <TenancyLawCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpTenancyLawAdvocard;
